import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  EncouragingIcon,
  PatientIcon,
  FriendlyIcon,
  FocusedIcon,
  ForwardArrow,
  TrashIconGray,
  EditIconGray,
  EditIconDarkGray,
} from "../../constant/imagePath";
import classes from "./commonQuestions.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Accordion } from "react-bootstrap";
import { Button } from "../Button/Button";
import { ReactSVG } from "react-svg";

export const CommonQuestions = ({
  heading,
  data,
  customStyle,
  handleDelete,
  handleEdit,
  btnsPosition,
  headingStyle,
  padding,
  descriptionClass,
}) => {
  const [open, setOpen] = useState(null);

  function toggleActive(id) {
    if (open === id) {
      setOpen(null);
    } else {
      setOpen(id);
    }
  }

  return (
    <div className={` ${[classes.commonQuestions].join(" ")}`}>
      <style jsx>{`
        .accordion-item {
          border: 0px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.125);
          border-top: 1px solid rgba(0, 0, 0, 0.125);
          padding: 0px;
        }
        .accordion-button:not(.collapsed) {
          color: ${Colors.neutralShadesOfNero};
        }
        .accordion-button {
          padding: ${padding ? padding : "16px 0px"};
        }
        .accordion-body {
          padding: 0px 0px 16px 0px;
        }
      `}</style>
      {heading && (
        <h4
          style={{
            ...Fonts.h4,
            color: Colors.neutralShadesOfNero,
            fontSize: "26px",
            ...headingStyle,
          }}
        >
          {heading}
        </h4>
      )}
      <Accordion
        className={`${[classes.customAccordion].join(" ")}`}
        style={customStyle}

        // style={{ border: `1px solid ${Colors.neutralShadesOfWhisper}` }}
      >
        {data?.map((item, i) => {
          return (
            <Accordion.Item eventKey={i} style={customStyle}>
              <Accordion.Header
                className={`${[classes.header].join(" ")}`}
                onClick={() => toggleActive(i)}
              >
                <div
                  className={
                    (handleDelete || handleEdit) && classes.headerTitleWithBtns
                  }
                  style={{ width: "100%", height: "100%" }}
                >
                  <div
                    className={` ${[classes.headingWithIcon].join(" ")}`}
                    style={{
                      border: 0,
                      boxShadow: "unset",
                      backgroundColor: "transparent",
                    }}
                  >
                    <span className={`${[classes.svgIcon].join(" ")}`}>
                      <ReactSVG
                        src={ForwardArrow}
                        beforeInjection={(svg) => {
                          svg.classList.add(
                            classes.icon,
                            i == open ? classes.down : classes.left
                          );
                        }}
                      />
                    </span>
                    <h6
                      style={{
                        width: "100%",
                        ...Fonts.h7,
                        lineHeight: "24px",
                        fontFamily: "inter-600",
                        color: Colors.neutralShadesOfNero,
                      }}
                    >
                      {item?.title}
                    </h6>
                  </div>

                  {btnsPosition === "Top" && (
                    <div className={classes.btnBox}>
                      {open === i && handleDelete && (
                        <Button
                          icon={TrashIconGray}
                          onClick={() => handleDelete(item)}
                          primary={false}
                          size={"Small"}
                          customStyle={{
                            marginRight: "10px",
                            border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                          }}
                        />
                      )}
                      {open === i && handleEdit && (
                        <Button
                          icon={EditIconDarkGray}
                          onClick={() => handleEdit(item)}
                          primary={false}
                          size={"Small"}
                          customStyle={{
                            border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <p
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
                  className={descriptionClass}
                >
                  {item?.description}
                </p>
                {/* Btns  */}
                {btnsPosition === "Bottom" && (
                  <div className={classes.bottomsBtns}>
                    {handleDelete && (
                      <Button
                        icon={TrashIconGray}
                        onClick={() => handleDelete(item)}
                        primary={false}
                        size={"Small"}
                        customStyle={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                          marginRight: "8px",
                        }}
                      />
                    )}
                    {handleEdit && (
                      <Button
                        size={"Small"}
                        icon={EditIconDarkGray}
                        onClick={() => handleEdit(item)}
                        primary={false}
                        customStyle={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                        }}
                      />
                    )}
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
};

CommonQuestions.propTypes = {
  data: PropTypes.array,
  heading: PropTypes.string,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  headingStyle: PropTypes.object,
  btnsPosition: PropTypes.oneOf(["Top", "Bottom"]),
  padding: PropTypes.string,
};

CommonQuestions.defaultProps = {
  data: [
    {
      title: "Can I bring more than one person?",
      description:
        "For most people, a weekly tennis lesson is about the right number to maintain their development, as long as they are playing at least once per week on top of this.",
    },
    {
      title: "Are there any other fees?",
      description:
        "For most people, a weekly tennis lesson is about the right number to maintain their development, as long as they are playing at least once per week on top of this.",
    },
    {
      title: "Can we speak before the lesson?",
      description:
        "For most people, a weekly tennis lesson is about the right number to maintain their development, as long as they are playing at least once per week on top of this.",
    },
    {
      title: "Do you offer a free trial lesson?",
      description:
        "For most people, a weekly tennis lesson is about the right number to maintain their development, as long as they are playing at least once per week on top of this.",
    },
  ],
};
